import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnWidgetObject extends SnModel {
  @Expose()
  public contentType: string;

  @Expose()
  public object: any;

  @Expose()
  public objectId: string;

  @Expose()
  public widget: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
